// extracted by mini-css-extract-plugin
export default {"font-renta":"NavigationMenu_font-renta__3upem","navigationMenu":"NavigationMenu_navigationMenu__dx2rH"};